import { QueryFactory } from '@lmt/shared-types';

export function useRoles() {
  return QueryFactory.RoleQuery.useGetRolesQuery().data ?? [];
}
